import TankGame from "../../assets/Tank_Game.png";
import FoodsOnly from "../../assets/FoodsOnly.png";
import FileSystem from "../../assets/FileSystem.png";
import DatabaseBot from "../../assets/DatabaseBot.png";
import OnlineBingo from "../../assets/Online_Bingo.png";
import VideoShare from "../../assets/Video_Sharing.png";

export const projectsData = [
  {
    id: 1,
    image: FoodsOnly,
    title: "Foods Only",
    category: "web",
    deployed: "true",
    repo: "https://github.com/BulbaWasTaken/Foods-Only",
    link: "https://foods-only-website.vercel.app",
    description: "A forum-style web",
  },
  {
    id: 2,
    image: OnlineBingo,
    title: "Online Bingo",
    category: "web",
    deployed: "false",
    repo: "https://github.com/BulbaWasTaken/Bingo-Website",
    link: "N/A",
  },
  {
    id: 3,
    image: TankGame,
    title: "Tank Game",
    category: "game",
    deployed: "false",
    repo: "https://github.com/BulbaWasTaken/Tank-Game",
    link: "N/A",
    downloadPath: "../../assets/Bulba_Tank_Game.jar",
  },
  {
    id: 4,
    image: FileSystem,
    title: "Basic File System",
    category: "os",
    deployed: "false",
    repo: "https://github.com/BulbaWasTaken/File-System-Project",
    link: "N/A",
  },
  {
    id: 5,
    image: VideoShare,
    title: "Video Sharing Website",
    category: "web",
    deployed: "true",
    repo: "https://github.com/BulbaWasTaken/Video-Sharing-Website",
    link: "https://www.youtube.com/watch?v=Nu7IuQwlpns",
  },
  {
    id: 6,
    image: DatabaseBot,
    title: "MySQL Discord Bot",
    category: "database",
    deployed: "false",
    repo: "https://github.com/BulbaWasTaken/Database-Systems",
    link: "N/A",
  },
];
